/**
 * Inventory family: shared store URL param + "remember the last store"
 * (issue #507).
 *
 * Every inventory page (Count, variance, variance history) standardizes on
 * ?store=. ?store_no= is still READ as a fallback so old links and bookmarks
 * keep working, but every page now WRITES ?store=.
 *
 * Plain functions in their own .ts file (not storesShared.tsx) so react-refresh's
 * only-export-components rule doesn't flag mixing them with that file's
 * component exports.
 */

export function readInventoryStoreParam(sp: URLSearchParams): number | null {
  const raw = sp.get('store') ?? sp.get('store_no');
  return raw && /^\d+$/.test(raw) ? Number(raw) : null;
}

// True when the URL already carries an explicit store choice, including a
// deliberate "no store" (param present but not a valid number, e.g. History's
// All-stores view). Distinguishes "nothing picked yet" (worth prefilling from
// the last remembered store) from "the user already chose" (leave it alone).
export function hasInventoryStoreParam(sp: URLSearchParams): boolean {
  return sp.has('store') || sp.has('store_no');
}

const LAST_INVENTORY_STORE_KEY = 'cockpit.inventory.store';

export function readLastInventoryStore(): number | null {
  try {
    const raw = window.localStorage.getItem(LAST_INVENTORY_STORE_KEY);
    const n = raw ? Number(raw) : NaN;
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export function writeLastInventoryStore(storeNo: number): void {
  try {
    window.localStorage.setItem(LAST_INVENTORY_STORE_KEY, String(storeNo));
  } catch {
    // Ignore storage errors (private mode, quota, etc.).
  }
}
